import { ReactNode } from 'react'

import Container from '@/components/Container'
import Footer from '@/components/Footer'
import NavBar from '@/components/NavBar'
import PageWrapper from '@/components/PageWrapper'
import { Toaster } from '@/components/ui/toaster'

const Page = ({
  children,
  className,
  wrapContainer = true
}: {
  children: ReactNode
  className?: string
  wrapContainer?: boolean
}) => {
  return (
    <PageWrapper className={className}>
      <NavBar sticky />
      {wrapContainer ? <Container>{children}</Container> : children}
      <Footer />
      <Toaster />
    </PageWrapper>
  )
}

export default Page
